import React, { ReactNode } from 'react';
import { ControllerType } from '@/types/ControllerType';
import { HookFormContext } from '@/context/HookFormContext';

export interface IHookFormProviderProps {
    children: ReactNode;
    controller: ControllerType;
}

const HookFormProvider = ({ children, controller }: IHookFormProviderProps) => (
    <HookFormContext value={{ controller }}>{children}</HookFormContext>
);

export default HookFormProvider;
